function openNewPageWithSearchStringValue(searchValue, type){
    const baseUrl = window.location.href.split('&')[0];

    let url;

    if(type == 'base'){
        url = `${baseUrl}&q=${searchValue.toLowerCase()}`;
    }
    if(type == 'video'){
        url = `${removeCatalogPath(baseUrl)}/?videos&q=${searchValue.toLowerCase()}`;
    }

    window.location.href = url;
}

function removeCatalogPath(row){
    var regex = /\/\?catalog/;
    return row.replace(regex, '');
}

$(document).on('click', '.js-main-search-btn', function(){
    let searchValue = $('.js-main-search').val();

    let type;
    if($(this).hasClass('js-open-base-url')){
        type = 'base'
    }
    if($(this).hasClass('js-open-video-url')){
        type = 'video'
    }

    openNewPageWithSearchStringValue(searchValue, type);
});

